<div class="risultato__container">
    <div class="risultato__wrapper">
        <span class="material-symbols-outlined icon">
            report
        </span>
        <div class="title">
            {{titolo | translate}}
        </div>
        <div class="subtitle">
            {{sottotitolo | translate}}
        </div>
    </div>
</div>